import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, Typography, getTestId, useBreakpoint } from '@airtel/air-design-system';
import { Image, View } from 'react-native';
import { getMarkerImageHeight, getMarkerImageWidth, getTrustMarkerWidgetStyles } from './TrustMarkerWidgetStyles';
export var TrustMarkerWidgetComponent = props => {
  var brandUrl = props.brandUrl,
    brandUrlSize = props.brandUrlSize,
    heading = props.heading,
    subHeading = props.subHeading,
    subHeadingImageUrl = props.subHeadingImageUrl,
    _props$markerUrls = props.markerUrls,
    markerUrls = _props$markerUrls === void 0 ? [] : _props$markerUrls,
    _props$markerUrlSize = props.markerUrlSize,
    markerUrlSize = _props$markerUrlSize === void 0 ? 'sm' : _props$markerUrlSize,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'TrustMarkerWidget' : _props$testID,
    brandAccessibilityProps = props.brandAccessibilityProps,
    markerAccessibilityProps = props.markerAccessibilityProps,
    style = props.style;
  var trustMarkerWidgetStyles = getTrustMarkerWidgetStyles(markerUrlSize);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var markerSizes = {
    width: getMarkerImageWidth(markerUrlSize, isLargeScreen),
    height: getMarkerImageHeight(markerUrlSize, isLargeScreen)
  };
  return _jsxs(View, Object.assign({}, getTestId(testID), {
    style: [trustMarkerWidgetStyles.container, style]
  }, {
    children: [brandUrl && _jsx(Image, Object.assign({
      resizeMode: "contain",
      style: trustMarkerWidgetStyles.topImage,
      source: {
        uri: brandUrl,
        width: (brandUrlSize === null || brandUrlSize === void 0 ? void 0 : brandUrlSize.width) || 100,
        height: (brandUrlSize === null || brandUrlSize === void 0 ? void 0 : brandUrlSize.height) || 32
      }
    }, getTestId(testID, 'brandUrl'), brandAccessibilityProps)), _jsxs(View, Object.assign({
      style: trustMarkerWidgetStyles.contentContainer
    }, {
      children: [heading && _jsx(Typography, Object.assign({
        text: heading,
        type: isLargeScreen ? 'body-single-line-md' : 'body-single-line-sm'
      }, getTestId(testID, 'heading'))), _jsxs(View, Object.assign({
        style: trustMarkerWidgetStyles.subHeadingContainer
      }, {
        children: [subHeading && _jsx(Typography, Object.assign({
          color: BLACK_700,
          text: subHeading,
          type: isLargeScreen ? 'body-para-sm' : 'body-para-xs'
        }, getTestId(testID, 'subHeading'))), subHeadingImageUrl && _jsx(Image, Object.assign({
          resizeMode: "contain",
          style: trustMarkerWidgetStyles.subHeadingImageUrl,
          source: {
            uri: subHeadingImageUrl,
            width: markerSizes.width,
            height: markerSizes.height
          }
        }, getTestId(testID, 'subHeadingImageUrl')))]
      }))]
    })), (markerUrls === null || markerUrls === void 0 ? void 0 : markerUrls.length) > 0 && _jsx(View, Object.assign({
      style: trustMarkerWidgetStyles.markerUrlsContainer
    }, getTestId(testID, "markerUrls"), {
      children: markerUrls.map((singleMarkerUrl, index) => {
        return _jsx(Image, Object.assign({
          resizeMode: "contain",
          style: trustMarkerWidgetStyles.singleMarkerUrl,
          source: {
            uri: singleMarkerUrl,
            width: markerSizes.width,
            height: markerSizes.height
          }
        }, markerAccessibilityProps === null || markerAccessibilityProps === void 0 ? void 0 : markerAccessibilityProps[index]), "singleMarkerUrl_" + index);
      })
    }))]
  }));
};
TrustMarkerWidgetComponent.genericRendererKey = 'AirTrustMarkerWidget';